import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
  token: null,
  userId: null,
  errors: null,
  errorJson: null,
  loading: false,
  user: null,
  openLogin: false,
  openRegister: false,
  openCellphoneVerification: false,
  verifySend: {
    loading: false,
    errors: null,
  },
  verification: {
    loading: false,
    errors: null,
  },
  reloadCategories: false,
  countNotif: 0,
};

const authSetCountNotif = (state, action) => {
  return updateObject(state, {
    countNotif: action.count,
  });
};

const authReloadCategory = (state, action) => {
  return updateObject(state, {
    reloadCategories: action.reload,
  });
};

const authVerifySendLoad = (state, action) => {
  return updateObject(state, {
    verifySend: {
      loading: action.loading,
      errors: action.errors,
    },
  });
};

const authVerificationLoad = (state, action) => {
  return updateObject(state, {
    verification: {
      loading: action.loading,
      errors: action.errors,
    },
  });
};

const authModal = (state, action) => {
  return updateObject(state, {
    openLogin: action.openLogin,
    openRegister: action.openRegister,
    openCellphoneVerification: action.openCellphoneVerification,
  });
};

const authStart = (state, action) => {
  return updateObject(state, { errorJson: null, error: null, loading: true });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    token: action.token,
    userId: action.userId,
    user: action.user,
    errors: null,
    errorJson: null,
    loading: false,
  });
};

const authFail = (state, action) => {
  return updateObject(state, {
    errorJson: action.errorJson,
    errors: action.errors,
    loading: false,
  });
};

const authErrorRemoved = (state, action) => {
  let errors = state.errors;
  let nameField = action.name;

  if (errors != null && errors[nameField]) {
    delete errors[nameField];
  }

  return updateObject(state, {
    errorJson: null,
    errors: errors,
    loading: false,
  });
};

const authLogout = (state, action) => {
  return updateObject(state, { token: null, userId: null, user: null });
};

const authLoad = (state, action) => {
  return updateObject(state, { error: null, errorJson: null });
};

const authSetServer = (state, action) => {
  return updateObject(state, {
    token: action.token,
  });
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.AUTH_LOAD:
      return authLoad(state, action);
    case actionTypes.AUTH_ERROR_REMOVE:
      return authErrorRemoved(state, action);
    case actionTypes.AUTH_MODAL_STATUS:
      return authModal(state, action);
    case actionTypes.AUTH_VERIFICATION_LOAD:
      return authVerificationLoad(state, action);
    case actionTypes.AUTH_VERIFYSEND_LOAD:
      return authVerifySendLoad(state, action);
    case actionTypes.AUTH_SET_SERVER:
      return authSetServer(state, action);
    case actionTypes.AUTH_RELOAD_CATEGORY:
      return authReloadCategory(state, action);
    case actionTypes.AUTH_NOTIF_COUNT:
      return authSetCountNotif(state, action);
    default:
      return state;
  }
};

export default authReducer;
